import { toast } from 'sonner'

interface UsePaymentJustificationProps {
  justificationFileLength: number
  testId: string
}
export function usePaymentJustification({
  testId,
  justificationFileLength,
}: UsePaymentJustificationProps) {
  const fileSizeMB = Number(
    import.meta.env?.VITE_MAX_FILE_SIZE_MB ?? window.env.MAX_FILE_SIZE_MB,
  )

  function handleJustificationFileValidation(
    event: React.ChangeEvent<HTMLInputElement>,
  ) {
    const validFileTypes = ['application/pdf']
    const files = event.target.files

    // 5MB
    const maxFileSize = fileSizeMB * 1024 * 1024

    if (files && files.length > 0) {
      const currentFilesCount = justificationFileLength ?? 0
      const newFilesCount = files.length

      if (currentFilesCount + newFilesCount > 3) {
        toast.warning('Você só pode fazer upload de no máximo 3 documentos', {
          className: `${testId}-warning-toast`,
        })
        return
      }
      const validatedFiles = Array.from(files).filter((file) => {
        if (!validFileTypes.includes(file.type)) {
          toast.warning('Selecione um arquivo do tipo PDF', {
            className: `${testId}-warning-toast`,
          })
          return false
        }
        if (file.size > maxFileSize) {
          toast.warning(`Tamanho máximo de arquivo excedido: ${fileSizeMB}MB`, {
            className: `${testId}-warning-toast`,
          })
          return false
        }
        return true
      })

      return validatedFiles
    }
  }

  return {
    handleFileValidation: handleJustificationFileValidation,
    fileSizeMB,
  }
}
